import { render } from "./MainMenu.vue?vue&type=template&id=0e5aaa61&scoped=true&ts=true"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=0e5aaa61&lang=scss&scoped=true"

import exportComponent from "/builds/project/shmu/shmu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5aaa61"]])

export default __exports__